import { normalizeLearningLocale, resolveTranslatedText } from '@features/learning'
import type { FlashcardCard } from '@services/firebase/flashcards'

export function normalizeFlashcardLocale(locale: string) {
  return normalizeLearningLocale(locale)
}

export function resolveFlashcardTranslation(
  card: FlashcardCard,
  locale: string,
) {
  return resolveTranslatedText(card.translates, normalizeFlashcardLocale(locale))
}
